import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    curisLoading : false,
    currency: [],
    totalCurrency: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    curiscLoading:false,
    curstatus:"",
    curMessage:"",
    curdetails:{},
    ismloading:false,
    curmstatus:"",
    curmmessage:"",
    currencies: {},
    curdstatus:"",
    curdmessage:"",
    
};


const currencyListSlice = createSlice({
    name: "currencyList",
    initialState,
    reducers:{
        getCurrencyPending: (state) => {
            state.curisLoading = true;
        },
        getCurrencySuccess: (state, { payload }) => {
            state.curisLoading = false;
            state.currency = payload;
            state.curdetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getCurrencyFail: (state, { payload }) => {
            state.curisLoading = false;
            state.error = payload;
        },
        createCurrencyPending:(state,action) => {
            state.curiscloading=true;
        },
        createCurrencySuccess:(state,{payload}) => {
            state.curiscloading=false;
            state.curstatus="success";
            state.curMessage=payload;
        },
        createCurrencyFail:(state,{payload}) => {
            state.curiscloading=false;
            state.curstatus="fail";
            //console.log('slice '+payload);
            state.curmessage=payload;
        },
        getSCurrencyPending: (state) => {
            state.curisLoading = true;
        },
        getSCurrencySuccess: (state, { payload }) => {
            state.curisLoading = false;
            state.currencies=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSCurrencyFail: (state, { payload }) => {
            state.curisLoading = false;
            state.error = payload;
        },
        modifyCurrencyPending:(state,action) => {
            state.curismloading=true;
            state.curmstatus="";
        },
        modifyCurrencySuccess:(state,{payload}) => {
            state.curismloading=false;
            state.curmstatus="success";
           
            state.curmmessage="Currency Successfully Updated";
        },
        modifyCurrencyFail:(state,{payload}) => {
            state.curismloading=false;
            state.curmstatus="fail";
           // console.log('slice '+payload);
            state.curmmessage=payload;
        },
        deleteCurrencyPending:(state,action) => {
            state.curisloading=true;
            state.curdstatus="";
        },
        deleteCurrencySuccess:(state,{payload}) => {
            state.curisLoading=false;
            state.curdstatus="success";
            state.curdmessage="Currency Successfully Deleted";
        },
        deleteCurrencyFail:(state,{payload}) => {
            state.curisLoading=false;
            state.curdstatus="fail";
           // console.log('slice '+payload);
            state.curdmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = currencyListSlice;

export const { getCurrencyPending, getCurrencySuccess, getCurrencyFail,getSCurrencyPending, getSCurrencySuccess, getSCurrencyFail, 
    createCurrencyPending, createCurrencySuccess, createCurrencyFail,
    modifyCurrencyPending,modifyCurrencySuccess,modifyCurrencyFail,
    deleteCurrencyPending,deleteCurrencySuccess,deleteCurrencyFail  } = actions;

export default reducer;
